import { useState } from "react";
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Menu,
  MenuItem,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import {
  Dashboard,
  Business,
  ShoppingCart,
  AccountBalance,
  People,
  BarChart,
  Settings,
  ChevronRight,
  ArrowBack,
} from "@mui/icons-material";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const MobileBottomNav = () => {
  const history = useHistory();
  const location = useLocation();
  const { permissions } = useAuth();
  const [value, setValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [transactionSubMenu, setTransactionSubMenu] = useState(null); // 'purchase' or 'sales'
  const [productSubMenu, setProductSubMenu] = useState(false); // For Product submenu
  const [accountMasterSubMenu, setAccountMasterSubMenu] = useState(false); // For Account Master submenu
  const [masterSubMenu, setMasterSubMenu] = useState(false); // For Master (Client/Vendor) submenu

  const hasReadMasterPermission = permissions.includes('Read Master');
  const hasReadAccountsPermission = permissions.includes('Read Accounts');
  const hasReadAdministrationPermission = permissions.includes('Read Administration');
  const hasReadReportsPermission = permissions.includes('Read Reports');

  const handleMenuOpen = (event, menuId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(menuId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveMenu(null);
    setTransactionSubMenu(null);
    setProductSubMenu(false);
    setAccountMasterSubMenu(false);
    setMasterSubMenu(false);
  };

  const handleNavigation = (path) => {
    history.push(path);
    handleMenuClose();
  };

  const menuItems = {
    accountMaster: [
      { label: 'Account Head', route: '/AccountHeadIndex' },
      { label: 'Asset', route: '/AssetIndex' },
      { label: 'Capital', route: '/CapitalIndex' },
      { label: 'Others', route: '/OtherOptionIndex' },
      { label: 'Balance Sheet', route: '/BalanceSheetHeadIndex' },
    ],
    master: [
      { label: 'Account Master', isNested: true, subMenuKey: 'accountMaster' }, // Account Master will have submenu
      { label: 'Bank', route: '/BankIndex' },
      { label: 'Company', route: '/CompanyEdit' },
      { label: 'Master', isNested: true, subMenuKey: 'masterSub' }, // Master will have submenu
      { label: 'Product', isNested: true, subMenuKey: 'product' }, // Product will have submenu
      // { label: 'Staff', route: '/StaffDashboard' },
    ],

    masterSub: [
      { label: 'Client', route: '/ClientIndex' },
      { label: 'Vendor', route: '/VendorIndex' },
    ],

    product: [
      { label: 'Category', route: '/ProductCategoryIndex' },
      { label: 'Brand', route: '/ProductBrandIndex' },
      { label: 'Item', route: '/ProductItemIndex' },
      { label: 'Product Relations', route: '/ProductRelationIndex' },
    ],


    transaction: {
      purchase: [

        { label: 'Purchase', route: '/PurchaseIndex' },
        { label: 'Purchase Return', route: '/PurchaseReturnAgainstIndex' },

      ],

      sales:
        [

          { label: 'Sales', route: '/SaleIndex' },
          { label: 'Sale Return', route: '/SaleReturnAgainstIndex' },
        ],

    },
    accounts: [
      { label: 'Payment & Receipt', route: '/PaymentAndReceiptIndex' },
      { label: 'Journal Entry', route: '/JournalEntryIndex' },
    ],
    reports: [
      { label: 'Cash Book', route: '/CashBook' },
      { label: 'Ledger', route: '/Ledger' },
      // { label: 'Vendor Due List', route: '/VendorDueList' },
      // { label: 'Customer Due List', route: '/CustomerDueList' },
      { label: 'Vendor Ageing', route: '/VendorAging' },
      { label: 'Customer Ageing', route: '/CustomerAging' },
      { label: 'Outstanding', route: '/Outstanding' },
      { label: 'Income Expense Summary', route: '/IncomeExpenseSummary' },
      { label: 'Purchase Party & ItemWise Report', route: '/PurchasePartyandItemWiseReport' },
      { label: 'Sale Party & ItemWise Report', route: '/SalePartyandItemWiseReport' },
      { label: 'Stock Report', route: '/StockReport' },
      { label: 'Detailed Invoice', route: '/DetailedInvoiceReport' },
    ],
    settings: [
      { label: 'Users', route: '/UserIndex' },
      { label: 'Roles', route: '/RoleIndex' },
      { label: 'Reset Password', route: '/PasswordChange' },
    ],
  };

  return (
    <>
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          borderTop: '1px solid rgba(0,0,0,0.1)',
        }}
        elevation={8}
      >
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => setValue(newValue)}
          sx={{
            background: "linear-gradient(135deg, #0f172a 0%, #4e024e 50%, #081642ff 100%)",
            height: '60px',
            '& .MuiBottomNavigationAction-root': {
              color: 'rgba(255,255,255,0.6)',
              minWidth: '50px',
              padding: '6px 0',
              '&.Mui-selected': {
                color: '#fff',
              },
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '10px',
              fontWeight: 500,
              marginTop: '2px',
            },
          }}
        >
          <BottomNavigationAction
            label="Home"
            icon={<Dashboard sx={{ fontSize: 22 }} />}
            onClick={() => history.push('/Home')}
          />
          {hasReadMasterPermission && (
            <BottomNavigationAction
              label="Master"
              icon={<Business sx={{ fontSize: 22 }} />}
              onClick={(e) => handleMenuOpen(e, 'master')}
            />
          )}
          {hasReadMasterPermission && (
            <BottomNavigationAction
              label="Transaction"
              icon={<ShoppingCart sx={{ fontSize: 22 }} />}
              onClick={(e) => handleMenuOpen(e, 'transaction')}
            />
          )}
          {hasReadAccountsPermission && (
            <BottomNavigationAction
              label="Accounts"
              icon={<AccountBalance sx={{ fontSize: 22 }} />}
              onClick={(e) => handleMenuOpen(e, 'accounts')}
            />
          )}
          {hasReadReportsPermission && (
            <BottomNavigationAction
              label="Reports"
              icon={<BarChart sx={{ fontSize: 22 }} />}
              onClick={(e) => handleMenuOpen(e, 'reports')}
            />
          )}
          <BottomNavigationAction
            label="More"
            icon={<Settings sx={{ fontSize: 22 }} />}
            onClick={(e) => handleMenuOpen(e, 'settings')}
          />
        </BottomNavigation>
      </Paper>

      {/* Master Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'master'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: "linear-gradient(135deg, #0f172a 0%, #4e024e 50%, #081642ff 100%)",
            color: 'white',
            borderRadius: '12px',
            minWidth: '180px',
            mb: 1,
          }
        }}
      >
        {!productSubMenu && !accountMasterSubMenu && !masterSubMenu ? (
          // Main master menu
          menuItems.master.map((item, idx) => (
            item.isNested ? (
              <MenuItem
                key={idx}
                onClick={() => {
                  if (item.subMenuKey === 'product') setProductSubMenu(true);
                  else if (item.subMenuKey === 'accountMaster') setAccountMasterSubMenu(true);
                  else if (item.subMenuKey === 'masterSub') setMasterSubMenu(true);
                }}
                sx={{
                  fontSize: '14px',
                  py: 1.5,
                  display: 'flex',
                  justifyContent: 'space-between',
                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
                }}
              >
                <span>{item.label}</span>
                <ChevronRight sx={{ fontSize: 18 }} />
              </MenuItem>
            ) : (
              <MenuItem
                key={idx}
                onClick={() => handleNavigation(item.route)}
                sx={{ fontSize: '14px', py: 1.5, '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
              >
                {item.label}
              </MenuItem>
            )
          ))
        ) : productSubMenu ? (
          // Product submenu
          <>
            <MenuItem
              onClick={() => setProductSubMenu(false)}
              sx={{
                fontSize: '14px',
                py: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                borderBottom: '1px solid rgba(255,255,255,0.2)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
              }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              <span style={{ fontWeight: 600 }}>Product</span>
            </MenuItem>
            {menuItems.product.map((item, idx) => (
              <MenuItem
                key={idx}
                onClick={() => handleNavigation(item.route)}
                sx={{ fontSize: '14px', py: 1.5, '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
              >
                {item.label}
              </MenuItem>
            ))}
          </>
        ) : accountMasterSubMenu ? (
          // Account Master submenu
          <>
            <MenuItem
              onClick={() => setAccountMasterSubMenu(false)}
              sx={{
                fontSize: '14px',
                py: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                borderBottom: '1px solid rgba(255,255,255,0.2)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
              }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              <span style={{ fontWeight: 600 }}>Account Master</span>
            </MenuItem>
            {menuItems.accountMaster.map((item, idx) => (
              <MenuItem
                key={idx}
                onClick={() => handleNavigation(item.route)}
                sx={{ fontSize: '14px', py: 1.5, '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
              >
                {item.label}
              </MenuItem>
            ))}
          </>
        ) : (
          // Master (Client/Vendor) submenu
          <>
            <MenuItem
              onClick={() => setMasterSubMenu(false)}
              sx={{
                fontSize: '14px',
                py: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                borderBottom: '1px solid rgba(255,255,255,0.2)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
              }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              <span style={{ fontWeight: 600 }}>Master</span>
            </MenuItem>
            {menuItems.masterSub.map((item, idx) => (
              <MenuItem
                key={idx}
                onClick={() => handleNavigation(item.route)}
                sx={{ fontSize: '14px', py: 1.5, '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
              >
                {item.label}
              </MenuItem>
            ))}
          </>
        )}
      </Menu>

      {/* Transaction Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'transaction'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: "linear-gradient(135deg, #0f172a 0%, #4e024e 50%, #081642ff 100%)",
            color: 'white',
            borderRadius: '12px',
            minWidth: '220px',
            maxHeight: '70vh',
            mb: 1,
          }
        }}
      >
        {!transactionSubMenu ? (
          // Main transaction menu
          <>
            <MenuItem
              onClick={() => setTransactionSubMenu('purchase')}
              sx={{
                fontSize: '14px',
                py: 1.5,
                display: 'flex',
                justifyContent: 'space-between',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
              }}
            >
              <span>Purchase</span>
              <ChevronRight sx={{ fontSize: 18 }} />
            </MenuItem>
            <MenuItem
              onClick={() => setTransactionSubMenu('sales')}
              sx={{
                fontSize: '14px',
                py: 1.5,
                display: 'flex',
                justifyContent: 'space-between',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
              }}
            >
              <span>Sales</span>
              <ChevronRight sx={{ fontSize: 18 }} />
            </MenuItem>
          </>
        ) : (
          // Sub-menu (Purchase or Sales)
          <>
            <MenuItem
              onClick={() => setTransactionSubMenu(null)}
              sx={{
                fontSize: '14px',
                py: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                borderBottom: '1px solid rgba(255,255,255,0.2)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
              }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              <span style={{ fontWeight: 600 }}>
                {transactionSubMenu === 'purchase' ? 'Purchase' : 'Sales'}
              </span>
            </MenuItem>
            {/* Menu items */}
            {menuItems.transaction[transactionSubMenu].map((item, idx) => (
              <MenuItem
                key={idx}
                onClick={() => handleNavigation(item.route)}
                sx={{ fontSize: '13px', py: 1.2, '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
              >
                {item.label}
              </MenuItem>
            ))}
          </>
        )}
      </Menu>

      {/* Accounts Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'accounts'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: "linear-gradient(135deg, #0f172a 0%, #4e024e 50%, #081642ff 100%)",
            color: 'white',
            borderRadius: '12px',
            minWidth: '180px',
            mb: 1,
          }
        }}
      >
        {menuItems.accounts.map((item, idx) => (
          <MenuItem
            key={idx}
            onClick={() => handleNavigation(item.route)}
            sx={{ fontSize: '14px', py: 1.5, '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Reports Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'reports'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: "linear-gradient(135deg, #0f172a 0%, #4e024e 50%, #081642ff 100%)",
            color: 'white',
            borderRadius: '12px',
            minWidth: '180px',
            mb: 1,
          }
        }}
      >
        {menuItems.reports.map((item, idx) => (
          <MenuItem
            key={idx}
            onClick={() => handleNavigation(item.route)}
            sx={{ fontSize: '14px', py: 1.5, '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Settings Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'settings'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            background: "linear-gradient(135deg, #0f172a 0%, #4e024e 50%, #081642ff 100%)",
            color: 'white',
            borderRadius: '12px',
            minWidth: '180px',
            mb: 1,
          }
        }}
      >
        {menuItems.settings.map((item, idx) => (
          <MenuItem
            key={idx}
            onClick={() => handleNavigation(item.route)}
            sx={{ fontSize: '14px', py: 1.5, '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MobileBottomNav;
